import { render, staticRenderFns } from "./AnfaelleRoot.vue?vue&type=template&id=9e9016d8&scoped=true"
import script from "./AnfaelleRoot.vue?vue&type=script&lang=js"
export * from "./AnfaelleRoot.vue?vue&type=script&lang=js"
import style0 from "./AnfaelleRoot.vue?vue&type=style&index=0&id=9e9016d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9016d8",
  null
  
)

export default component.exports